export default __webpack_public_path__ + "static/media/toggle.9700a777.svg";